<template>
  <div>
    <van-popup v-model="isView" position="right" :style="{ height: '100%', width: '100%', background: '#fff' }">
      <van-nav-bar fixed>
        <div slot="left" @click="close">
          <van-icon name="arrow-left" color="#333" size="19" />
        </div>
        <div slot="title">筛选</div>
      </van-nav-bar>
      <div class="xy-module-content">
        <van-cell title="校区/年级" is-link v-if="isStatistics">
          <span class="schoolname" :title="schoolArr[0]+schoolArr[1]" @click="school=true">{{schoolArr[0]+"/"+schoolArr[1]}}</span>
        </van-cell>
        <van-cell title="学年/学期" is-link>
          <span class="schoolname" :title="yearArr[0]+yearArr[1]" @click="year=true">{{yearArr[0]+"/"+yearArr[1]}}</span>
        </van-cell>
        <van-cell title="学科" is-link v-if="isStatistics">
          <span class="schoolname" :title="subjTextectText" @click="subject=true">{{subjTextectText}}</span>
        </van-cell>
        <van-cell title="开始时间" is-link>
          <span class="schoolname" :title="startDateText" @click="isStartDate=true">{{startDateText}}</span>
        </van-cell>
        <van-cell title="结束时间" is-link>
          <span class="schoolname" :title="endDateText" @click="isEndDate=true">{{endDateText}}</span>
        </van-cell>
      </div>
      <div class="search-footer">
        <div class="cancel" @click="reset">重置</div>
        <div class="submit" @click="submitSearch">确定</div>
      </div>
    </van-popup>
    <!-- 学校 -->
    <van-popup
      round
      v-model="school"
      position="bottom"
      :style="{ height: '40%', width: '100%', background: '#fff' }"
      >
      <van-picker ref="school" @confirm="schoolConfirm" @cancel="school=false"  show-toolbar title="" :columns="schoolGradeList" />
    </van-popup>
    <!-- 学年学期 -->
    <van-popup
      round
      v-model="year"
      position="bottom"
      :style="{ height: '40%', width: '100%', background: '#fff' }"
      >
      <van-picker ref="year" @confirm="yearConfirm" @cancel="year=false"  show-toolbar title="" :columns="yearSemesterList" />
    </van-popup>
    <!-- 学科 -->
    <van-popup
      round
      v-model="subject"
      position="bottom"
      :style="{ height: '40%', width: '100%', background: '#fff' }"
      >
      <van-picker ref="subject" @confirm="subjectConfirm" @cancel="subject=false"  show-toolbar title="" :columns="subjectList" />
    </van-popup>
    <!-- 开始时间 -->
    <van-popup
      v-model="isStartDate"
      position="bottom"
      :style="{ height: '40%', width: '100%', background: '#fff' }"
      >
      <van-datetime-picker
        :max-date="maxDate"
        v-model="startDate"
        @confirm="startDateOk"
        @cancel="isStartDate=false"
        type="date"
        />
      </van-popup>
      <!-- 结束时间 -->
      <van-popup
        v-model="isEndDate"
        position="bottom"
        :style="{ height: '40%', width: '100%', background: '#fff' }"
        >
        <van-datetime-picker
          :max-date="maxDate"
          v-model="endDate"
          @confirm="endDateOk"
          @cancel="isEndDate=false"
          type="date"
          />
      </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    isView: Boolean,
    isStatistics:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      maxDate: new Date(2090, 10, 1),
      school:false,
      year:false,
      time:false,
      isStartDate:false,
      isEndDate:false,
      subject:false,
      value: '',
      showPicker: false,
      schoolDistrictID: '', // 校区
      studentGradeForStudentYearID: '', // 年级
      AcademicYearID:'',//学年
      academicSessionID: '', // 学期
      startDate:'',//开始时间-绑定的
      startDateText:'',//开始时间-传值
      endDate:'',//结束时间-绑定的
      endDateText:'',//结束时间-传值
      schoolArr:[],//显示校区年级
      yearArr:[],//显示学年学期
      timerArr:[],//显示时间
      schoolGradeList:[],
      yearSemesterList:[],
      subjTextectText:'',
      subjTextectId:'',
      // 存值
      model:{
        schoolDistrictID:'',
        studentGradeForStudentYearID:'',
        AcademicYearID:'',
        academicSessionID:'',
        startDate:'',
        startDateText:'',
        endDate:'',
        endDateText:'',
        schoolArr:[],
        yearArr:[],
        timerArr:[],
        subjTextectId:'',
        subjTextectText:''
      },
      subjectList:[]
    }
  },
  created(){
    this.getSchoolGrade()
  },
  methods:{
      // 获取学科
      async fetchSubject () {
        this.xy.loading()
        const params = {
          starTime: this.startDateText,
          endTime: this.endDateText,
          academicSessionID: this.academicSessionID,
          schoolDistrictID: this.schoolDistrictID,
          studentGradeForStudentYearID: this.studentGradeForStudentYearID
        }
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/AverageRecord/GetDisciplinesByID`, params)
        this.xy.unloading()
        if (res.success) {
          this.subjectList = []
          if (res.data.length) {
            this.subjectList = res.data
            this.subjectList.forEach(item=>{
              item.value = item.DisciplineID
              item.text = item.DisciplineName
            })
            this.subjectList.unshift({ value: '0', text: '所有学科' })

            this.subjTextectText = this.subjectList[0].text
            this.model.subjTextectText = this.subjectList[0].text

            this.subjTextectId = this.subjectList[0].value
            this.model.subjTextectId = this.subjectList[0].value
          }else{
            this.subjTextectText = "暂无学科"
            this.subjTextectId='0'
          }
        }
      },
     // 获取校区、年级
      getSchoolGrade () {
        this.xy.loading()
        this.xyapi.get(`${this.xyMApi}/xy/comm/GetSchoolDistrictForStudentGradeStudentYears`).then(res => {
          this.xy.unloading()
          if (res.success) {
            let resData = res.data
            resData.map(item => {
              item.value = item.ID
              item.text = item.Name
              item.children = item.Childrens
              item.children.map(cItem => {
                // cItem.value = cItem.StudentYearForSchoolDistrictID//before
                cItem.value = cItem.StudentGradeForStudentYearID
                cItem.text = cItem.FullName
                return cItem
              })
              return item
            })
            this.schoolGradeList = res.data
            if (this.schoolGradeList.length > 0 && this.schoolGradeList[0].children.length > 0) {
              this.schoolDistrictID=this.schoolGradeList[0].value
              this.model.schoolDistrictID=this.schoolGradeList[0].value
              this.studentGradeForStudentYearID=this.schoolGradeList[0].children[0].value
              this.model.studentGradeForStudentYearID=this.schoolGradeList[0].children[0].value
              this.schoolArr=[this.schoolGradeList[0].text,this.schoolGradeList[0].children[0].text]
              this.model.schoolArr=[this.schoolGradeList[0].text,this.schoolGradeList[0].children[0].text]
            }
            this.getTableSessionNodeList()
          }
        })
      },
      // 获取学年、学期
      getTableSessionNodeList () {
        this.xy.loading()
        this.xyapi.get(`${this.xyMApi}/xy/comm/GetSessionNodeList`).then(res => {
          this.xy.unloading()
          if (res.success) {
            res.data.map(item => {
              item.text = item.label
              item.children.map(cItem => {
                cItem.text = cItem.label
                // 防止出现三列的情况
                if(cItem.children.length===0){
                  delete cItem.children
                }
                return cItem
              })
              return item
            })
            this.yearSemesterList = res.data

            let index = this.yearSemesterList.map(item => {
              return item.IsCurrent
            }).indexOf(true)
            if (index !== -1) {
              // 学年
              this.AcademicYearID=this.yearSemesterList[index].value
              this.model.AcademicYearID=this.yearSemesterList[index].value
              this.yearArr.push(this.yearSemesterList[index].label)
              this.model.yearArr.push(this.yearSemesterList[index].label)
              let index1 = this.yearSemesterList[index].children.map(item => {
                return item.IsCurrent
              }).indexOf(true)
              if (index1 !== -1) {
                // 学期
                this.academicSessionID=this.yearSemesterList[index].children[index1].value
                this.model.academicSessionID=this.yearSemesterList[index].children[index1].value
                this.model.yearArr.push(this.yearSemesterList[index].children[index1].label)
                this.yearArr.push(this.yearSemesterList[index].children[index1].label)
                // this.model.startDate=new Date(this.yearSemesterList[index].children[index1].StartDate)
                // this.startDate=new Date(this.yearSemesterList[index].children[index1].StartDate)
                this.model.startDate=new Date(this.xy.moment(this.yearSemesterList[index].children[index1].StartDate).format("YYYY-MM-DD"))
                this.startDate=new Date(this.xy.moment(this.yearSemesterList[index].children[index1].StartDate).format("YYYY-MM-DD"))
                this.model.startDateText=this.xy.moment(this.yearSemesterList[index].children[index1].StartDate).format('YYYY-MM-DD')
                this.startDateText=this.xy.moment(this.yearSemesterList[index].children[index1].StartDate).format('YYYY-MM-DD')
                this.model.endDate=new Date()
                this.endDate=new Date()
                this.endDateText=this.xy.moment(new Date()).format('YYYY-MM-DD')
                this.model.endDateText=this.xy.moment(new Date()).format('YYYY-MM-DD')
              }
            } else {
              if (this.yearSemesterList.length > 0) {
                this.yearArr=[]
                this.yearArr.push(this.yearSemesterList[0].label)
                this.yearArr.push(this.yearSemesterList[0].children[0].label)
                this.AcademicYearID = this.yearSemesterList[0].value
                this.academicSessionID = this.yearSemesterList[0].children[0].value
                this.startDate = new Date(this.xy.moment(this.yearSemesterList[0].children[0].StartDate).format("YYYY-MM-DD"))
                this.endDate = new Date(this.xy.moment(this.yearSemesterList[0].children[0].EndDate).format("YYYY-MM-DD")) 
                this.startDateText=this.xy.moment(this.yearSemesterList[0].children[0].StartDate).format('YYYY-MM-DD')
                this.endDateText=this.xy.moment(this.yearSemesterList[0].children[0].EndDate).format('YYYY-MM-DD')
                this.model.AcademicYearID = this.yearSemesterList[0].value
                this.model.academicSessionID = this.yearSemesterList[0].children[0].value
                this.model.startDate = new Date(this.xy.moment(this.yearSemesterList[0].children[0].StartDate).format("YYYY-MM-DD"))
                this.model.endDate = new Date(this.xy.moment(this.yearSemesterList[0].children[0].EndDate).format("YYYY-MM-DD")) 
                this.model.startDateText=this.xy.moment(this.yearSemesterList[0].children[0].StartDate).format('YYYY-MM-DD')
                this.model.endDateText=this.xy.moment(this.yearSemesterList[0].children[0].EndDate).format('YYYY-MM-DD')
              }
            }
           this.fetchSubject()
          }
        })
      },
     onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    close() {
      this.$emit("listenToChildClose", false);
    },
    submitSearch(){
      let option={
        schoolDistrictID:this.schoolDistrictID,
        studentGradeForStudentYearID:this.studentGradeForStudentYearID,
        AcademicYearID:this.AcademicYearID,
        academicSessionID:this.academicSessionID,
        startDateText:this.startDateText,
        endDateText:this.endDateText,
        subjTextectId:this.subjTextectId
      }
      this.$emit("listenToChildCSubmit", option);
    },
    reset(){
        this.schoolDistrictID=this.model.schoolDistrictID
        this.studentGradeForStudentYearID=this.model.studentGradeForStudentYearID
        this.AcademicYearID=this.model.AcademicYearID
        this.academicSessionID=this.model.academicSessionID
        this.startDate=this.model.startDate
        this.startDateText=this.model.startDateText
        this.endDate=this.model.endDate
        this.endDateText=this.model.endDateText
        this.schoolArr=this.model.schoolArr
        this.yearArr=this.model.yearArr
        this.timerArr=this.model.timerArr
        if(this.subjectList.length===0){
          this.subjTextectText="暂无学科"
        }else{
          this.subjTextectId=this.model.subjTextectId
          this.subjTextectText=this.model.subjTextectText
        }
    },
    schoolConfirm(value){
      this.schoolArr=value
      this.schoolDistrictID = this.schoolGradeList[this.$refs.school.getIndexes()[0]].value
      this.studentGradeForStudentYearID = this.schoolGradeList[this.$refs.school.getIndexes()[0]].children[this.$refs.school.getIndexes()[1]].value
      this.school=false
      // 获取学科
      this.fetchSubject()
    },
    yearConfirm(value){
      this.AcademicYearID = this.yearSemesterList[this.$refs.year.getIndexes()[0]].value//学年
      this.academicSessionID = this.yearSemesterList[this.$refs.year.getIndexes()[0]].children[this.$refs.year.getIndexes()[1]].value
      this.yearSemesterList.forEach((item,index)=>{
        if(item.value === this.AcademicYearID){
          if(item.children){
            item.children.forEach((item1,index1)=>{
              if(item1.value=== this.academicSessionID){
                // this.startDate=new Date(this.yearSemesterList[index].children[index1].StartDate)
                this.startDate = new Date(this.xy.moment(this.yearSemesterList[index].children[index1].StartDate).format("YYYY-MM-DD"))
                this.startDateText = this.xy.moment(this.yearSemesterList[index].children[index1].StartDate).format('YYYY-MM-DD')
                // this.endDate=new Date(this.yearSemesterList[index].children[index1].EndDate)
                this.endDate = new Date(this.xy.moment(this.yearSemesterList[index].children[index1].EndDate).format("YYYY-MM-DD"))
                this.endDateText = this.xy.moment(this.yearSemesterList[index].children[index1].EndDate).format('YYYY-MM-DD')
              }
            })
          }
        }
      })
      this.yearArr=value
      this.year=false
      // 获取学科
      this.fetchSubject()
    },
    // 开始时间
    startDateOk(value){
      this.isStartDate=false
      this.startDateText=this.xy.moment(value).format("YYYY-MM-DD")
      // this.fetchSubject()
    },
    // 结束时间
    endDateOk(value){
      this.isEndDate=false
      this.endDateText=this.xy.moment(value).format("YYYY-MM-DD")
      // this.fetchSubject()
    },
    subjectConfirm(value){
      this.subject=false
      this.subjTextectText = value.text
      this.subjTextectId = value.value
    }
  }
}

</script>
<style lang="less" scoped>
.search-footer{
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  height: 80px;
  line-height: 80px;
  .cancel{
    flex:0.5;
    text-align: center;
    background: #E9E9E9;
    color:#161616;
  }
  .submit{
    flex:0.5;
    text-align: center;
    background: #2980FE;
    color: #fff;
  }
}
.xy-module-content {
  margin-top: 110px;
  /deep/ .van-cell__value{
    color:#606060;
  }
  /deep/ .van-cell__title {
    color:#606060;
  }
  .schoolname{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }
}
</style>